/**
 * @author NikolaV
 */
import * as React from 'react';
import { cs } from '@shared/utils/utils-classname';
import { DateTimeSpan } from '@shared/ui-react/UtilComponents';
import './LogpointApprovalsList.scss';
import { Button } from '@shared/ui-react/Button';


export class LogpointApprovalsList extends React.Component<{
    latestApproval: ILogpointApproval,
    approvals: ILogpointApproval[],
    onChangeApproval: (LogpointApprovalStage) => void
}, {}> {

    static icons = {
        APPROVED: 'iki iki-check',
        CHECKED: 'iki iki-show',
        MEASURED: 'iki iki-asbuilt',
    };

    state = {
        isHistoryOpen: false,
    };

    onUndo = () => {
        const stage = this.props.latestApproval ? this.props.latestApproval.approveId.toLocaleLowerCase() : null;
        if (stage === 'measured') {
            return;
        }
        else if (stage === 'checked') {
            this.props.onChangeApproval('MEASURED');
        }
        else if (stage === 'approved') {
            this.props.onChangeApproval('CHECKED');
        }
    }

    render() {
        if (!this.props.approvals) return null;

        const sortedApprovals = this.props.approvals ? this.props.approvals.sort((b, a) => a.timestamp - b.timestamp) : [];
        const stage = this.props.latestApproval ? this.props.latestApproval.approveId.toLocaleLowerCase() : null;
        const userActiveRole = kuura.getActiveRole() != null && kuura.getActiveRole().length==1 ? kuura.getActiveRole().toString(): "";

        const canUndo = stage === 'checked' || stage === 'approved';
        const canCheck = (stage == null || stage == 'measured') && userActiveRole !== 'ROLE_SUPERVISOR';
        const canApprove = stage === 'checked' && userActiveRole !== 'ROLE_EQUIPMENT_OPERATOR';

        return (
            <div className={cs('logpoint-info-approval-wrapper', stage)}>
                <div className='logpoint-info-approval-latest'>
                    {sortedApprovals.length > 0 ?
                        this.makeTable(sortedApprovals) :
                        <strong className='text-center no-break-text'>{__('js_logpoints.logpoint_has_no_approvals')}</strong>}
                </div>

                <div className='logpoint-info-approval-controls'>
                    {canUndo && <Button secondary subtle small onClick={this.onUndo} icon='iki iki-reset'>
                        {__('js_logpoints.approval.undo')}
                    </Button>}

                    {canCheck &&
                        <button id='js-logpoint-info-check-btn' className='ik-button-secondary--subtle ik-button-small'
                                onClick={() => this.props.onChangeApproval('CHECKED')} >
                                <i className='iki iki-show'/><span>{__('js_logpoints.approval.check')}</span>
                        </button>
                    }

                    {canApprove &&
                        <button id='js-logpoint-info-approve-btn' className='ik-button-secondary--subtle ik-button-small'
                                onClick={() => this.props.onChangeApproval('APPROVED')}>
                            <i className='iki iki-check'/><span>{__('js_logpoints.approval.approve')}</span>
                        </button>}
                </div>
            </div>
        );
    }

    makeTable(approvals: ILogpointApproval[]) {
        return (<table>
            <tbody>
            {approvals.map(a => {
                const username = a.user.username + (a.user.id == kuura.getUserId() ? (' (' + __('general.me') + ')') : '');

                return <tr className='no-break-text approval-line' key={a.id}>
                    <td><i className={LogpointApprovalsList.icons[a.approveId]}/></td>
                    <td><span>{a.approveId}</span></td>
                    <td><span>{username}</span></td>
                    <td><DateTimeSpan timestamp={a.timestamp}/></td>
                </tr>;
            })}
            </tbody>
        </table>);
    }
}
